import {createContext} from 'react'

// Backend stores area in square feet (area_sqft).
// Multipliers convert sqft → display unit.
export const units = [
    {
        name: 'Sq ft',
        value: 1           // 1 sqft = 1 sqft
    },
    {
        name: 'Acres',
        value: 1 / 43560   // 1 sqft = 0.0000229568 acres
    }
]

export const LandSizeUnitContext =  createContext({
    value: units[0],
    changeUnit: ()=> {}
})
